module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Frank G. Honeycutt\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('BR'), _c('B', [_vm._v("Frank Honeycutt")]), _vm._v(" is a Lutheran (ELCA) pastor who has authored numerous books and articles. His writing interests include short fiction, homiletics, and catechesis . An avid hiker and cyclist, Frank has backpacked the length of the Appalachian Trail and bicycled across the country from the Puget Sound to the Maine coast.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/DjwhSi/tc-custom/9781467466547.jpg?1730407957698",
      "alt": "This image is the cover for the book Miracles for Skeptics"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Miracles for Skeptics\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Are the miracle stories in the Bible actually true?")]), _c('br'), _c('br'), _vm._v(" Christians and skeptics alike may doubt the veracity of Jesus’s miracles. Preachers often rely on a dry, literal interpretation of his healings and wonders, or else try to tame them and explain them away rationally. Both approaches, in their obsession with historical accuracy, miss the truth behind these stories."), _c('br'), _c('br'), _vm._v(" Frank G. Honeycutt draws out the deeper truths in the weird incidents in the Bible. In a warm, conversational style, Honeycutt reads iconic miracle stories—from the wedding at Cana to demonic exorcisms—to enrich the life of faith. Digging into these “unbelievable” stories can widen our spiritual imaginations and point to the promise of Christ’s new world. Pastors seeking thoughtful    resources and any inquisitive reader will find a wealth of pastoral insight and scriptural wisdom in "), _c('i', [_vm._v("Miracles for Skeptics")]), _vm._v(".\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0